import i18n from 'shared/lib/i18n';

import {
  CREATE_ACCESS_CARD_FAILURE,
  CREATE_ACCESS_CARD_REQUEST,
  CREATE_ACCESS_CARD_SUCCESS,
  DELETE_ACCESS_CARD_FAILURE,
  DELETE_ACCESS_CARD_REQUEST,
  DELETE_ACCESS_CARD_SUCCESS,
  GET_ACCESS_CARDS_LIST_FAILURE,
  GET_ACCESS_CARDS_LIST_REQUEST,
  GET_ACCESS_CARDS_LIST_SUCCESS,
  GET_ACCESS_CARD_FAILURE,
  GET_ACCESS_CARD_REQUEST,
  GET_ACCESS_CARD_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  SET_MODAL_TYPE,
  UPDATE_ACCESS_CARD_FAILURE,
  UPDATE_ACCESS_CARD_REQUEST,
  UPDATE_ACCESS_CARD_SUCCESS,
  VALIDATE_ACCESS_CARD_FAILURE,
  VALIDATE_ACCESS_CARD_REQUEST,
  VALIDATE_ACCESS_CARD_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';
import { history } from '../../store';
import { CONFIRM } from '../Modal/modalTypes';

export const getAccessCardsList = (
  dispatch,
  queryParams,
  isBatch,
  isExport,
) => {
  const requestType = isBatch ? 'getBatchList' : 'getList';
  return dispatch({
    type: GET_ACCESS_CARDS_LIST_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.accessCard[requestType](queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_ACCESS_CARDS_LIST_SUCCESS,
          isBatch,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_ACCESS_CARDS_LIST_FAILURE,
          isBatch,
          err,
        }),
    ),
  });
};

export const createAccessCard = (dispatch, data, isBatch) => {
  const requestType = isBatch ? 'createBatch' : 'create';
  return dispatch({
    type: CREATE_ACCESS_CARD_REQUEST,
    isForm: true,
    payload: apiClient.accessCard[requestType](data).then(
      (res) => {
        dispatch({
          type: CREATE_ACCESS_CARD_SUCCESS,
          isBatch,
          res,
        });
        history.goBack();
        return res;
      },
      (err) => {
        dispatch({
          type: CREATE_ACCESS_CARD_FAILURE,
          isBatch,
          err,
        });
        return err;
      },
    ),
  });
};

export const getAccessCard = (dispatch, id, isBatch) => {
  if (Number.isNaN(id)) return null;
  const requestType = isBatch ? 'getBatchById' : 'getById';
  return dispatch({
    type: GET_ACCESS_CARD_REQUEST,
    payload: apiClient.accessCard[requestType](id).then(
      (res) => {
        dispatch({
          type: GET_ACCESS_CARD_SUCCESS,
          isBatch,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_ACCESS_CARD_FAILURE,
          isBatch,
          err,
        }),
    ),
  });
};

export const deleteAccessCard = (dispatch, id, queryParams, isBatch) => {
  const requestType = isBatch ? 'deleteBatchById' : 'deleteById';
  return dispatch({
    type: DELETE_ACCESS_CARD_REQUEST,
    payload: apiClient.accessCard[requestType](id).then(
      (res) => {
        dispatch({
          type: DELETE_ACCESS_CARD_SUCCESS,
          isBatch,
          res,
        });
        return getAccessCardsList(dispatch, queryParams, isBatch);
      },
      (err) =>
        dispatch({
          type: DELETE_ACCESS_CARD_FAILURE,
          isBatch,
          err,
        }),
    ),
  });
};

export const confirmDeleteAccessCard = (
  dispatch,
  accessCardId,
  queryParams,
  isBatch,
) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: () =>
      deleteAccessCard(dispatch, accessCardId, queryParams, isBatch),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const updateAccessCard = (dispatch, accessCardId, data, isBatch) => {
  const requestType = isBatch ? 'updateBatchById' : 'updateById';
  return dispatch({
    type: UPDATE_ACCESS_CARD_REQUEST,
    isForm: true,
    payload: apiClient.accessCard[requestType](accessCardId, data).then(
      (res) => {
        dispatch({
          type: UPDATE_ACCESS_CARD_SUCCESS,
          isBatch,
          res,
        });
        history.goBack();
        return res;
      },
      (err) => {
        dispatch({
          type: UPDATE_ACCESS_CARD_FAILURE,
          isBatch,
          err,
        });
        return err;
      },
    ),
  });
};

export const validateAccessCard = (dispatch, data) =>
  dispatch({
    type: VALIDATE_ACCESS_CARD_REQUEST,
    payload: apiClient.accessCard.validate(data).then(
      (res) => {
        dispatch({
          type: VALIDATE_ACCESS_CARD_SUCCESS,
          res,
        });
        return true;
      },
      (err) => {
        dispatch({
          type: VALIDATE_ACCESS_CARD_FAILURE,
          err,
        });
        return false;
      },
    ),
  });
